import { useEffect } from 'react';
import TrackingService from '../services/trackingService';
import { migrateDetailedResultsFromUrl } from '../utils/detailedResultsStorage';

// Custom hook to initialize tracking on app mount
export const useTrackingInitialization = () => {
  useEffect(() => {
    migrateDetailedResultsFromUrl();
    const trackingService = TrackingService.getInstance();
    trackingService.initialize();
  }, []);
};

export default useTrackingInitialization;
